/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Typography } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import { clearError } from "../../Services/redux/ApplicationDetailsError/ApplicationDetailsErrorActions";
import error from "../../assets/images/error.png"
import "./ApplicationDetailsErrorDialog.css";

function ApplicationDetailsErrorDialog() {
  const { errorMessage, errorType, errorCount } = useSelector(
    (state) => state.errors
  );
  const dispatch = useDispatch();

  const handleCloseError = () => {
    dispatch(clearError());
  };

  const availableFailureText = {
    FETCH_ADDITIONAL_DOCUMENT_FAILURE: "Error uploading Additonal document",
    FETCH_DELETE_ADDITIONAL_DOCUMENT_FAILURE:
      "Error deleting Additional document",
    FETCH_BINARIES_DETAILS_FAILURE: "Error uploading new apk",
    FETCH_APPLICATION_ID_DETAILS_FAILURE: "Errorc calling application details",
    FETCH_APPLICATION_DETAILS_FAILURE: "Error while calling submission details",
    FETCH_BANNER_DETAILS_FAILURE: "Error uploading feature image",
    FETCH_BANNER_DELETE_FAILURE: "Error deleting the feature image",
    FETCH_CATEGORY_DETAILS_FAILURE: "Error calling categories details",
    FETCH_COUNTRY_DETAILS_FAILURE: "Error calling countries details",
    FETCH_CPU_DETAILS_FAILURE: "Error calling cpu details",
    FETCH_LANGUAGE_DETAILS_FAILURE: "Error calling language details",
    FETCH_SCREENSHOT_DETAILS_FAILURE: "Error uploading screenshots",
    FETCH_DELETE_SCREENSHOT_FAILURE: "Error deleting screenshots",
    FETCH_TEAM_DETAILS_FAILURE: "Error calling team details",
    FETCH_VEHICLES_DETAILS_FAILURE: "Error calling make details",
    FETCH_SUBMISSIONS_FAILURE: "Error calling all release",
    FETCH_FLEX_META_DATA_LABELS_FAILURE: "Error managing flex metadata labels",
  };

  return (
    <Dialog open={!!errorMessage} onClose={handleCloseError}>
      <DialogTitle>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent:"flex-start" }}>
             <div style={{ marginRight: "10px" , marginTop: "6px" }}>
             <img src={error} alt="Error" /> 
          </div>
           
          <div className="title-application-details-error-dialog">
            {availableFailureText[errorType]}
          </div>
          </div>
         
          <button 
            style={{
              cursor: "pointer", 
              marginRight: "10px", 
              background: "none", 
              border: "none", 
              padding: 0,
              display: "flex",
              alignItems: "center"
            }} 
            onClick={handleCloseError}
            aria-label="Close error dialog"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.6 16L0 14.4L6.4 8L0 1.6L1.6 0L8 6.4L14.4 0L16 1.6L9.6 8L16 14.4L14.4 16L8 9.6L1.6 16Z" fill="#121415" fillOpacity="0.6"/>
</svg>

          </button>
        </div>
      </DialogTitle>
      <DialogContent>
        <Typography
          sx={{
            font: "Roboto",
            fontWeight: 400,
            fontStyle: "Regular",
            fontSize: "14px",
            letterSpacing: "0.15px",
            color: "rgba(42, 44, 45, 1)",
          }}
        >
          {errorMessage}
        </Typography>
        {errorCount > 1 && (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              font: "Roboto",
              fontWeight: 400,
              fontStyle: "Regular",
              fontSize: "14px",
              letterSpacing: "0.15px",
              color: "rgba(42, 44, 45, 1)",
            }}
          >
            {errorCount - 1} similar error(s) occurred
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          sx={{
            background: "rgba(4, 118, 226, 1)",
            color: "rgba(255, 255, 255, 1)",
            fontSize: "14px",
            fontWeight: "500",
            textTransform: "none",
          }}
          onClick={handleCloseError}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ApplicationDetailsErrorDialog;
